module.exports = __webpack_public_path__ + "static/population-6b87c353f0315cd81f91bdd3d290793b.png";